import { Page } from "./models";

export const pagePermissions: Record<Page, string[]> = {
    Dashboard: ["Dashboard.Read", "Dashboard.Write"],
    Subscriptions: ["Subscriptions.Read", "Subscriptions.Write"],
    Invoices: ["Invoices.Read", "Invoices.Write"],
    PaymentMethods: ["PaymentMethods.Read", "PaymentMethods.Write"]
}